import { BaseAxios, MixedAxios, throwErrorResponse } from 'src/common/services/axios';
import { relatedCoursesLimit } from 'src/config/limits';
import { flatten } from 'src/lib/axios';
import { map } from 'ramda';
import { pipe } from 'fp-ts/lib/function';
import { ListWrapper, unwrap } from 'src/lib/listWrapper';
import { mapRelatedToCourseExcerpt, RelatedCourseDTO } from 'src/common/models/related';

export const mapRelated = (item: RelatedCourseDTO) => {
  return pipe(item, mapRelatedToCourseExcerpt);
};

export const getRelated = (elearningId: number, isLoggedIn: boolean) => {
  const request = isLoggedIn
    ? MixedAxios.get<ListWrapper<RelatedCourseDTO>>(`/api/courses/${elearningId}/related/all`, {
        params: { limit: relatedCoursesLimit },
      })
    : BaseAxios.get<ListWrapper<RelatedCourseDTO>>(
        `/api/public/courses/${elearningId}/related/all`,
        {
          params: { limit: relatedCoursesLimit },
        },
      );

  return request.then(flatten).then(unwrap).then(map(mapRelated)).catch(throwErrorResponse);
};
